import React, { useCallback, useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import ExportLoadingModal from "Components/Common/ExportLoadingModal";
import { exportPerformanceRatingsToCsv } from "common/services/performance-rating.service";
import Permission from "Components/Common/Permission";
import { toast } from "react-toastify";
import PerformanceRatingsImportModal from "./PerformanceRatingsImportModal";

const Import = ({
  apiParams,
  onImported,
}: {
  apiParams?: any;
  onImported?: () => void;
}) => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const [exporting, setExporting] = useState(false);
  const getCsvExport = useCallback(async () => {
    setExporting(true);

    await exportPerformanceRatingsToCsv({
      filters: apiParams.filters,
      sort: apiParams.sort,
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Performance_Ratings_Export.csv");
        link.click();
        link.remove();
      })
      .catch((error: any) => {
        toast.error("An error occurred while exporting performance ratings.");
      });

    setExporting(false);
  }, [apiParams]);
  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          className="btn btn-light"
          id="dropdownMenuButton"
        >
          <i className="ri ri-more-fill"></i>
        </DropdownToggle>
        <DropdownMenu>
          <Permission resource="performance-rating" action="import">
            <DropdownItem
              onClick={() => {
                setIsImportModalOpen(true);
              }}
            >
              <i className="ri ri-upload-2-line me-1"></i>
              Import
            </DropdownItem>
          </Permission>
          <Permission resource="performance-rating" action="exportToCsv">
            <DropdownItem
              onClick={() => {
                getCsvExport();
              }}
            >
              <i className="ri ri-download-2-line me-1"></i>
              Export
            </DropdownItem>
          </Permission>
        </DropdownMenu>
      </UncontrolledDropdown>

      <PerformanceRatingsImportModal
        toggle={() => setIsImportModalOpen(!isImportModalOpen)}
        isOpen={isImportModalOpen}
        onImported={onImported}
      />
      <ExportLoadingModal show={exporting} onCloseClick={() => {}} />
    </>
  );
};

export default Import;
